const REMEMBER_ME_KEY = 'appligerbe_remember_me';

export type StorageType = 'localStorage' | 'sessionStorage';

export const getRememberMePreference = (): boolean => {
  try {
    const saved = localStorage.getItem(REMEMBER_ME_KEY);
    return saved === 'true';
  } catch (error) {
    console.error('Error reading rememberMe preference:', error);
    return false;
  }
};

export const setRememberMePreference = (rememberMe: boolean): void => {
  try {
    localStorage.setItem(REMEMBER_ME_KEY, rememberMe.toString());
  } catch (error) {
    console.error('Error saving rememberMe preference:', error);
  }
};

export const getPreferredStorage = (): StorageType => {
  const rememberMe = getRememberMePreference();
  return rememberMe ? 'localStorage' : 'sessionStorage';
};

export const createAuthStorage = (storageType: StorageType) => {
  const storage = storageType === 'localStorage' ? localStorage : sessionStorage;

  return {
    getItem: (key: string) => {
      try {
        const item = storage.getItem(key);
        return item;
      } catch (error) {
        console.error(`Error accessing ${storageType}:`, error);
        return null;
      }
    },
    setItem: (key: string, value: string) => {
      try {
        storage.setItem(key, value);
      } catch (error) {
        console.error(`Error setting ${storageType}:`, error);
      }
    },
    removeItem: (key: string) => {
      try {
        storage.removeItem(key);
      } catch (error) {
        console.error(`Error removing from ${storageType}:`, error);
      }
    }
  };
};
